import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';

import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css'],
})
export class AlertDialogComponent implements OnInit {
  @Input() bodyContent: string;
  @Input() footerContent: string;
  @Input() headerContent: string;

  @Input() showBody: boolean = true;
  @Input() showFooter: boolean = false;
  @Input() showHeader: boolean = false;

  @Output() result: EventEmitter<string> = new EventEmitter();

  @ViewChild('alertDialog', { static: true }) alertDialogTemplate: TemplateRef<any>;

  modalRef: NgbModalRef | null;

  constructor(private modalService: NgbModal) {}

  // Component lifecycle events
  ngOnInit() {}

  // Component functions
  close(result: string) {
    this.modalRef!.close(result);
    this.resetDialog();
  }

  open(content: string) {
    this.bodyContent = content;
    return this.modalService.open(this.alertDialogTemplate);
  }

  openAndResult() {
    this.modalRef = this.modalService.open(this.alertDialogTemplate);
    this.modalRef.result.then(
      (result) => {
        this.result.emit(result);
        this.resetDialog();
      },
      (reason) => {
        this.result.emit(reason);
        this.resetDialog();
      }
    );
  }

  resetDialog() {
    this.bodyContent = '';
    this.footerContent = '';
    this.headerContent = '';
    this.modalRef = null;
    this.showBody = true;
    this.showFooter = false;
    this.showHeader = false;
  }
}
